import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../i18n';

const LanguageSelector = ({ variant = 'default' }) => {
  const { language, setLanguage, languages, languageNames } = useLanguage();

  if (variant === 'minimal') {
    return (
      <div className="flex items-center gap-1">
        {languages.map((lang) => (
          <button
            key={lang}
            onClick={() => setLanguage(lang)}
            className={`px-2 py-1 text-xs font-medium rounded transition-colors ${
              language === lang
                ? 'bg-[#0F7D70] text-white'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
            }`}
          >
            {lang.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="relative inline-flex items-center">
      <Globe size={16} className="text-gray-400 mr-2" />
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="appearance-none bg-transparent text-sm text-gray-600 hover:text-gray-900 cursor-pointer focus:outline-none pr-6"
        data-testid="language-selector"
      >
        {languages.map((lang) => (
          <option key={lang} value={lang}>
            {languageNames[lang]}
          </option>
        ))}
      </select>
      <svg
        className="absolute right-0 pointer-events-none w-4 h-4 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
};

export default LanguageSelector;
